import { render, staticRenderFns } from "./allOrderList.vue?vue&type=template&id=5675d34d&"
import script from "./allOrderList.vue?vue&type=script&lang=js&"
export * from "./allOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports